import { GoogleCalendarAuthButton } from '@/components/auth';
import { Benefits } from '@/components/SettingsModal/tabs/Calendars/components/Benefits';
import { useCollection } from '@/features/events/contexts/CollectionContext/useCollection';
import { getRedirectQuery } from '@/features/interactions/addToGoogle/util.lib';
import { PlatformTypes } from '@/types/gql.generated';
import { Button, Heading, Text } from '@/ui';
import { Card, CardBody } from '../Card';

type Props = {
  onComplete: () => void;
};

export const GoogleIntegrationBody = ({ onComplete }: Props) => {
  const { base } = useCollection();

  return (
    <>
      <Text fontSize="72px" mb="6" textAlign="center">
        ✅
      </Text>
      <Heading
        as="h2"
        fontSize={{ base: '2xl', sm: '4xl' }}
        fontWeight="bold"
        mb="10"
        textAlign="center"
      >
        Done! Your preferences are saved.
      </Heading>
      <Card mb="8" shadow="none">
        <CardBody flexDirection="column">
          <Benefits mb="6" />

          <GoogleCalendarAuthButton
            base={base ?? undefined}
            launchOnRedirect="set-preferred-platform"
            redirectParams={getRedirectQuery(base, {
              platform: PlatformTypes.GoogleIntegration,
            })}
          />
        </CardBody>
      </Card>

      <Button colorScheme="dark" variant="link" onClick={onComplete}>
        Maybe later
      </Button>
    </>
  );
};
